import { createReducer } from "sc/helpers/reducer";
import {
  PARTNER_PAGE_LOADED,
  PARTNER_UPDATE_REQUEST,
  PARTNER_UPDATED,
  PARTNER_UPDATE_ERROR,
  PARTNER_ADD_REQUEST,
  PARTNER_ADD_ERROR,
  PARTNER_QUEUE_ADD_REQUEST,
  PARTNER_QUEUE_ADD_ERROR,
  PARTNER_QUEUE_ADDED,
  PARTNER_QUEUE_DELETE_REQUEST,
  PARTNER_QUEUE_DELETE_ERROR,
  PARTNER_QUEUE_DELETED,
  PARTNER_LOGO_UPLOAD_REQUEST,
  PARTNER_LOGO_UPLOAD_ERROR,
  PARTNER_LOGO_UPLOADED,
  PARTNER_LOGO_DELETE_REQUEST,
  PARTNER_LOGO_DELETE_ERROR,
  PARTNER_LOGO_DELETED,
  PARTNER_LOGO_LOADED,
  PARTNER_LOGO_LOAD,
  PARTNER_LOGO_LOAD_ERROR,
} from "../actions/partners";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [PARTNER_PAGE_LOADED]: (state, action) => {
    const { queues, ...generalData } = action.payload.partner;
    const queuesWithState = queues.map(queue => ({
      value: queue,
      deleteInProgress: false,
    }));
    return Object.assign({}, generalData, {
      queues: queuesWithState,
      queueAddInProgress: false,
      generalDataSaveInProgress: false,
    });
  },
  [PARTNER_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [PARTNER_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [PARTNER_UPDATE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [PARTNER_UPDATED]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
    }),
  [PARTNER_UPDATE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [PARTNER_QUEUE_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      queueAddInProgress: true,
      queueAddError: "",
    }),
  [PARTNER_QUEUE_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      queueAddInProgress: false,
      queueAddError: action.payload.message,
    }),
  [PARTNER_QUEUE_ADDED]: (state, action) => {
    const { queues, ...generalData } = state;
    const updatedList = [
      ...queues,
      { value: action.payload.queue, deleteInProgress: false },
    ];
    return Object.assign({}, generalData, {
      queues: updatedList,
      queueAddInProgress: false,
    });
  },
  [PARTNER_QUEUE_DELETE_REQUEST]: (state, action) => {
    const { queues, ...generalData } = state;
    const updatedList = queues.map(queue => ({
      value: queue.value,
      deleteInProgress:
        queue.value === action.payload.queue ? true : queue.deleteInProgress,
    }));
    return Object.assign({}, generalData, { queues: updatedList });
  },
  [PARTNER_QUEUE_DELETE_ERROR]: (state, action) => {
    const { queues, ...generalData } = state;
    const updatedList = queues.map(queue => ({
      value: queue.value,
      deleteInProgress:
        queue.value === action.payload.queue ? false : queue.deleteInProgress,
    }));
    return Object.assign({}, generalData, { queues: updatedList });
  },
  [PARTNER_QUEUE_DELETED]: (state, action) => {
    const { queues, ...generalData } = state;
    const updatedList = queues.filter(
      queue => queue.value !== action.payload.queue,
    );
    return Object.assign({}, generalData, { queues: updatedList });
  },
  [PARTNER_LOGO_UPLOAD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      logoUploadInProgress: true,
      logoUploadError: "",
    }),
  [PARTNER_LOGO_UPLOAD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      logoUploadInProgress: false,
      logoUploadError: action.payload.message,
    }),
  [PARTNER_LOGO_UPLOADED]: (state, action) =>
    Object.assign({}, state, {
      logo: action.payload.imgSrc,
      logoUploadInProgress: false,
    }),
  [PARTNER_LOGO_DELETE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      logoDeleteInProgress: true,
      logoUploadError: "",
    }),
  [PARTNER_LOGO_DELETE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      logoDeleteInProgress: false,
      logoUploadError: action.payload.message,
    }),
  [PARTNER_LOGO_DELETED]: (state, action) =>
    Object.assign({}, state, {
      logo: action.payload.imgSrc,
      logoDeleteInProgress: false,
    }),
  [PARTNER_LOGO_LOAD]: (state, action) =>
    Object.assign({}, state, {
      logo: action.payload.logo,
      logoLoadInProgress: true,
    }),
  [PARTNER_LOGO_LOADED]: (state, action) =>
    Object.assign({}, state, {
      logo: action.payload.logo,
      logoLoadInProgress: false,
    }),
  [PARTNER_LOGO_LOAD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      logoLoadInProgress: false,
    }),
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/partner-reducer.js